import { ReactComponent as ContactIconSvg } from 'assets/icons/contact.svg';
import { ReactComponent as LogoIconSvg } from 'assets/icons/logo.svg';

import { ContactButton, LogoButton } from './LogoIcon.style';

const LogoIcon = () => (
  <>
    <LogoButton href="https://www.autronicafire.com/" target="_blank" rel="noopener">
      <LogoIconSvg />
    </LogoButton>
    <ContactButton href="https://www.autronicafire.com/en/contact-us/" target="_blank" rel="noopener">
      <ContactIconSvg />
    </ContactButton>
  </>
);

export default LogoIcon;
